<div class="value">
  @if (prependIcon) {
    <div
      pplPopover
      [pplPopoverTooltip]="prependText ? prependText : null"
      class="prepend-icon">
      <ppl-icon
        [svgIcon]="prependIcon"
        height="15px"
        width="15px"></ppl-icon>
    </div>
  }
  <input
    [attr.readonly]="!disabled && readonly ? 'true' : null"
    [disabled]="disabled"
    #valueInput
    class="number-input"
    pplInput
    [pplInputAutofill]="autoFill"
    [attr.min]="min"
    [attr.max]="max"
    [style.height]="height"
    [style.lineHeight]="height"
    [placeholder]="placeholder"
    autocomplete="off"
    [style.padding-right.px]="Math.max((clear ? 14 : 0) + (controls ? 20 : 0), 6)"
    (keydown)="onKeyDown($event)"
    (paste)="onPaste($event)"
    (focus)="focus.emit()"
    (blur)="blur.emit()" />
  @if (clear || controls) {
    <div
      class="misc"
      #misc>
      @if (clear) {
        <div
          class="clear"
          (click)="clearClick.emit()">
          <ppl-icon
            [svgIcon]="clearIcon || 'closering-red-white'"
            width="14px"
            height="14px"></ppl-icon>
        </div>
      }
      @if (controls && !disabled && !readonly) {
        <div class="controls">
          <div
            class="number number-up"
            #up
            (click)="onBumpValue(1)">
            <ppl-icon
              legacyWidth="6px"
              legacyHeight="4px"
              width="12px"
              height="12px"
              [actionElement]="up"
              [hoverEnabled]="!disabled && !readonly"
              fill="var(--ppl-color-300)"
              hoverFill="var(--ppl-color-700)"
              svgIcon="rowfull-up-darkblue"></ppl-icon>
          </div>
          <div
            class="number number-down"
            #down
            (click)="onBumpValue(-1)">
            <ppl-icon
              legacyWidth="6px"
              legacyHeight="4px"
              width="12px"
              height="12px"
              [actionElement]="down"
              [hoverEnabled]="!disabled && !readonly"
              fill="var(--ppl-color-300)"
              hoverFill="var(--ppl-color-700)"
              svgIcon="rowfull-down-darkblue"></ppl-icon>
          </div>
        </div>
      }
    </div>
  }
</div>
@if (unit) {
  <div
    class="unit"
    [attr.title]="unit">
    {{ unit }}
  </div>
}
